// src/ai/adminAiApi.ts
import { apiClient, getApiBaseUrl, getAuthHeaders, getStreamFetch } from "@maat/api-base";
var adminAiApi = {
  listConversations: async (params) => {
    return apiClient.get("/ai/api/admin/conversations", { params });
  },
  getConversation: async (id) => {
    return apiClient.get(`/ai/api/admin/conversations/${id}`);
  },
  getConversationSummary: async (id) => {
    return apiClient.get(`/ai/api/admin/conversations/${id}/summary`);
  },
  generate: async (promptType, payload) => {
    return apiClient.post(`/ai/api/admin/generate/${promptType}`, payload);
  },
  // ─── Message-feedback analytics (Overview dashboard) ───────────────────────
  getFeedbackSummary: async (days) => {
    return apiClient.get("/ai/api/admin/feedback/summary", { params: { days } });
  },
  getFeedbackTimeseries: async (days) => {
    return apiClient.get("/ai/api/admin/feedback/timeseries", { params: { days } });
  },
  listFeedbackComments: async (params) => {
    return apiClient.get("/ai/api/admin/feedback/comments", { params });
  },
  // ─── Generation audit ─────────────────────────────────────────────────────
  listGenerations: async (params) => {
    return apiClient.get("/ai/api/admin/generations", { params });
  },
  getGenerationsSummary: async (months) => {
    return apiClient.get("/ai/api/admin/generations/summary", { params: { months } });
  },
  // ─── Operator assistant ───────────────────────────────────────────────────
  /**
   * Initiates an SSE chat stream via POST, on the admin-gated route.
   *
   * Mirrors `aiApi.streamChat` but hits /ai/api/admin/chat/stream, because an
   * operator's session is the `admin_token` cookie — the consumer chat route
   * verifies a different secret and would 403. Returns the raw fetch Response
   * so the caller can consume the ReadableStream; auth rides the cookie via
   * credentials:'include'.
   */
  streamChat: async (message, conversationId, signal) => {
    const response = await getStreamFetch()(`${getApiBaseUrl()}/ai/api/admin/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
      credentials: "include",
      body: JSON.stringify({ message, conversationId }),
      signal
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: "Stream connection failed" }));
      throw new Error(errorData.message || `HTTP ${response.status}`);
    }
    return response;
  },
  /** Record a one-shot 👍/👎 on an assistant message in the operator assistant. */
  rateMessage: async (messageId, payload) => {
    return apiClient.post(`/ai/api/admin/messages/${messageId}/feedback`, payload);
  }
};

export {
  adminAiApi
};
